import imgOutside from '../../assetsFr/buildings/house/outside.jpg';
import { Building } from '../../interfaces/buildings';

const ksbCenterConfig: Building = {
    img: imgOutside
}

export default ksbCenterConfig;